import { parseDevPointer, type DevPointer } from '@muaa/shared'

const CACHE_KEY = 'muaa.admin.devRuntimePointer.v1'

export const DEV_SWITCH_ENABLED = import.meta.env.VITE_DEV_ENV_SWITCH === '1'

export async function fetchDevPointer(prodUrl: string, prodAnonKey: string, timeoutMs = 3000): Promise<DevPointer | null> {
  const controller = new AbortController()
  const timer = setTimeout(() => controller.abort(), timeoutMs)
  try {
    const res = await fetch(`${prodUrl}/rest/v1/dev_runtime_config?select=active_env,dev_url,dev_anon_key&limit=1`, {
      headers: { apikey: prodAnonKey, Authorization: `Bearer ${prodAnonKey}` },
      signal: controller.signal,
    })
    if (!res.ok) return null
    const rows = await res.json()
    // An absent or malformed row resolves to the prod target by design: resolveActiveBackend
    // requires activeEnv==='dev' + devUrl + devAnonKey to leave prod, so any null/missing
    // fields cause it to fall back to prod safely.
    return parseDevPointer(Array.isArray(rows) ? rows[0] : rows)
  } catch {
    return null
  } finally {
    clearTimeout(timer)
  }
}

export function readCachedPointerSync(): DevPointer | null {
  try {
    const raw = window.localStorage.getItem(CACHE_KEY)
    return raw ? (JSON.parse(raw) as DevPointer) : null
  } catch {
    return null
  }
}

export function writeCachedPointer(p: DevPointer | null): void {
  try {
    if (p) window.localStorage.setItem(CACHE_KEY, JSON.stringify(p))
    else window.localStorage.removeItem(CACHE_KEY)
  } catch {
    /* best-effort */
  }
}
